import { motion } from 'framer-motion';

export const Reveal = ({ children, delay = 0, y = 36, className = '' }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-80px' }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, accent = '#22D3EE' }) => (
  <p
    className="font-mono-precision text-xs uppercase tracking-[0.3em] mb-4"
    style={{ color: accent }}
    data-testid="section-eyebrow"
  >
    {children}
  </p>
);
